<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations de base sur l'assurance</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.postalCode || originalMetadata?.postalCode"
      >
        <span class="card__label" i18n>NPA</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.postalCode,
            }"
            >{{ metadata.postalCode }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.postalCode &&
              originalMetadata?.postalCode !== metadata.postalCode
            "
            >{{ originalMetadata.postalCode }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.sex || originalMetadata?.sex">
        <span class="card__label" i18n>Genre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.sex,
            }"
            >{{ getSexEnumLabel(metadata.sex) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sex && originalMetadata?.sex !== metadata.sex
            "
            >{{ getSexEnumLabel(originalMetadata.sex) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.hospitalInsurance || originalMetadata?.hospitalInsurance
        "
      >
        <span class="card__label" i18n>Assurance hospitalisation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.hospitalInsurance,
            }"
            >{{ getHospitalInsuranceLabel(metadata.hospitalInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hospitalInsurance &&
              originalMetadata?.hospitalInsurance !== metadata.hospitalInsurance
            "
            >{{
              getHospitalInsuranceLabel(originalMetadata.hospitalInsurance)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.startDate,
            }"
            >{{ metadata.startDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDate &&
              originalMetadata?.startDate !== metadata.startDate
            "
            >{{ originalMetadata.startDate }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.birthDate || originalMetadata?.birthDate"
      >
        <span class="card__label" i18n>Âge</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.birthDate,
            }"
          >
            {{ getAge(metadata.birthDate) }}
            <ng-container i18n>ans</ng-container>
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.birthDate &&
              originalMetadata?.birthDate !== metadata.birthDate
            "
          >
            {{ getAge(originalMetadata.birthDate) }}
            <ng-container i18n>ans</ng-container>
          </span>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.accidentInsurance || originalMetadata?.accidentInsurance
        "
      >
        <span class="card__label" i18n>Assurance accident ?</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.accidentInsurance,
            }"
            >{{ getBooleanLabel(metadata.accidentInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.accidentInsurance &&
              originalMetadata?.accidentInsurance !== metadata.accidentInsurance
            "
            >{{ getBooleanLabel(originalMetadata.accidentInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.prestations && metadata.prestations.length! > 0) ||
          (originalMetadata?.prestations &&
            originalMetadata.prestations.length > 0)
        "
      >
        <span class="card__label" i18n>Prestations</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !compareArrays(
                  metadata?.prestations!,
                  originalMetadata?.prestations!
                ),
            }"
          >
            <ng-container
              *ngFor="let prestation of metadata?.prestations; let last = last"
              >{{ getHealthPrestationsLabel(prestation)
              }}<ng-container *ngIf="!last">,</ng-container></ng-container
            >
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.prestations &&
              !compareArrays(
                metadata?.prestations!,
                originalMetadata?.prestations!
              )
            "
            ><ng-container
              *ngFor="
                let prestation of originalMetadata?.prestations;
                let last = last
              "
              >{{ getHealthPrestationsLabel(prestation)
              }}<ng-container *ngIf="!last">,</ng-container></ng-container
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    metadata.baseInsurance ||
    originalMetadata?.baseInsurance ||
    metadata.franchise >= 0 ||
    (originalMetadata?.franchise && originalMetadata.franchise >= 0)
  "
>
  <div cardTitle i18n>Modèles et primes</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Modèle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.baseInsurance,
            }"
            >{{ getHealthBaseInsuranceLabel(metadata.baseInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.baseInsurance &&
              originalMetadata?.baseInsurance !== metadata.baseInsurance
            "
            >{{
              getHealthBaseInsuranceLabel(originalMetadata.baseInsurance)
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.franchise,
            }"
            >{{ metadata.franchise }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.franchise &&
              originalMetadata?.franchise !== metadata.franchise
            "
            >{{ originalMetadata.franchise }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayComplementaryQuestionnary(metadata) ||
    displayComplementaryQuestionnary(originalMetadata)
  "
>
  <div cardTitle i18n>Questionnaire assurance complémentaire</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.paymentMethod || originalMetadata?.paymentMethod"
      >
        <span class="card__label" i18n>Méthode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.paymentMethod,
            }"
            >{{ getPaymentMethodLabel(metadata.paymentMethod!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.paymentMethod &&
              originalMetadata?.paymentMethod !== metadata.paymentMethod
            "
            >{{ getPaymentMethodLabel(originalMetadata.paymentMethod!) }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.iban || originalMetadata?.iban">
        <span class="card__label" i18n>IBAN</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.iban,
            }"
            >{{ metadata.iban }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.iban && originalMetadata?.iban !== metadata.iban
            "
            >{{ originalMetadata.iban }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.startDatePrestations ||
          originalMetadata?.startDatePrestations
        "
      >
        <span i18n class="card__label"
          >Date de début souhaitée d'assurance complémentaire</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.startDatePrestations,
            }"
            >{{ metadata.startDatePrestations }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDatePrestations &&
              originalMetadata?.startDatePrestations !==
                metadata.startDatePrestations
            "
            >{{ originalMetadata.startDatePrestations }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.avsNumber || originalMetadata?.avsNumber"
      >
        <span class="card__label" i18n>Numéro AVS</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.avsNumber,
            }"
            >{{ metadata.avsNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.avsNumber &&
              originalMetadata?.avsNumber !== metadata.avsNumber
            "
            >{{ originalMetadata.avsNumber }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.maritalStatus || originalMetadata?.maritalStatus"
      >
        <span class="card__label" i18n>Statut civil</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.maritalStatus,
            }"
            >{{ metadata.maritalStatus }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.maritalStatus &&
              originalMetadata?.maritalStatus !== metadata.maritalStatus
            "
            >{{ originalMetadata.maritalStatus }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.alreadySwicaClient !== null &&
            metadata?.alreadySwicaClient !== undefined) ||
          (originalMetadata?.alreadySwicaClient !== null &&
            originalMetadata?.alreadySwicaClient !== undefined)
        "
      >
        <span class="card__label" i18n>Déjà client Swica</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.alreadySwicaClient === null ||
                  originalMetadata.alreadySwicaClient === undefined),
            }"
            >{{ getBooleanLabel(metadata.alreadySwicaClient) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadySwicaClient &&
              originalMetadata?.alreadySwicaClient !==
                metadata.alreadySwicaClient
            "
            >{{ getBooleanLabel(originalMetadata.alreadySwicaClient) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.alreadyCssClient !== null &&
            metadata?.alreadyCssClient !== undefined) ||
          (originalMetadata?.alreadyCssClient !== null &&
            originalMetadata?.alreadyCssClient !== undefined)
        "
      >
        <span class="card__label" i18n>Déjà client CSS</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.alreadyCssClient === null ||
                  originalMetadata.alreadyCssClient === undefined),
            }"
            >{{ getBooleanLabel(metadata.alreadyCssClient) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadyCssClient &&
              originalMetadata?.alreadyCssClient !== metadata.alreadyCssClient
            "
            >{{ getBooleanLabel(originalMetadata.alreadyCssClient) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.refusedOrRestricted !== null &&
            metadata?.refusedOrRestricted !== undefined) ||
          (originalMetadata?.refusedOrRestricted !== null &&
            originalMetadata?.refusedOrRestricted !== undefined)
        "
      >
        <span i18n class="card__label"
          >SWICA ou d'autres assureurs ont-ils déjà refusé, ajourné ou accepté
          des demandes uniquement à des conditions plus restrictives ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.refusedOrRestricted === null ||
                  originalMetadata.refusedOrRestricted === undefined),
            }"
            >{{ getBooleanLabel(metadata.refusedOrRestricted) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.refusedOrRestricted &&
              originalMetadata?.refusedOrRestricted !==
                metadata.refusedOrRestricted
            "
            >{{ getBooleanLabel(originalMetadata.refusedOrRestricted) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.paymentFrequency || originalMetadata?.paymentFrequency"
      >
        <span class="card__label" i18n>Fréquence de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.paymentFrequency,
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.paymentFrequency &&
              originalMetadata?.paymentFrequency !== metadata.paymentFrequency
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency!)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDateBase || originalMetadata?.startDateBase"
      >
        <span class="card__label" i18n
          >Date de début souhaitée d'assurance de base</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.startDateBase,
            }"
            >{{ metadata.startDateBase }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDateBase &&
              originalMetadata?.startDateBase !== metadata.startDateBase
            "
            >{{ originalMetadata.startDateBase }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.bankNameAddress || originalMetadata?.bankNameAddress"
      >
        <span class="card__label" i18n>Banque</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.bankNameAddress,
            }"
            >{{ metadata.bankNameAddress }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.bankNameAddress &&
              originalMetadata?.bankNameAddress !== metadata.bankNameAddress
            "
            >{{ originalMetadata.bankNameAddress }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.alreadyGMClient !== null &&
            metadata?.alreadyGMClient !== undefined) ||
          (originalMetadata?.alreadyGMClient !== null &&
            originalMetadata?.alreadyGMClient !== undefined)
        "
      >
        <span class="card__label" i18n>Déjà client GroupeMutuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.alreadyGMClient === null ||
                  originalMetadata.alreadyGMClient === undefined),
            }"
            >{{ getBooleanLabel(metadata.alreadyGMClient) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadyGMClient &&
              originalMetadata?.alreadyGMClient !== metadata.alreadyGMClient
            "
            >{{ getBooleanLabel(originalMetadata.alreadyGMClient) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.alreadyHelsanaClient !== null &&
            metadata?.alreadyHelsanaClient !== undefined) ||
          (originalMetadata?.alreadyHelsanaClient !== null &&
            originalMetadata?.alreadyHelsanaClient !== undefined)
        "
      >
        <span class="card__label" i18n>Déjà client Helsana</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.alreadyHelsanaClient === null ||
                  originalMetadata.alreadyHelsanaClient === undefined),
            }"
            >{{ getBooleanLabel(metadata.alreadyHelsanaClient) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadyHelsanaClient &&
              originalMetadata?.alreadyHelsanaClient !==
                metadata.alreadyHelsanaClient
            "
            >{{ getBooleanLabel(originalMetadata.alreadyHelsanaClient) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.helsanaNumber || originalMetadata?.helsanaNumber"
      >
        <span class="card__label" i18n>N° Helsana</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.helsanaNumber,
            }"
            >{{ metadata.helsanaNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.helsanaNumber &&
              originalMetadata?.helsanaNumber !== metadata.helsanaNumber
            "
            >{{ originalMetadata.helsanaNumber }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12" *ngIf="metadata?.healthInfo">
  <div cardTitle i18n>Informations médicales</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hospitalStay !== null &&
            metadata?.healthInfo?.hospitalStay !== undefined) ||
          (originalMetadata?.healthInfo?.hospitalStay !== null &&
            originalMetadata?.healthInfo?.hospitalStay !== undefined)
        "
      >
        <span class="card__label" i18n>Traitement stationnaire</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hospitalStay === null ||
                  originalMetadata.healthInfo?.hospitalStay === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.hospitalStay) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hospitalStay &&
              originalMetadata?.healthInfo?.hospitalStay !==
                metadata.healthInfo?.hospitalStay
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hospitalStay)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasTransplant !== null &&
            metadata?.healthInfo?.hasTransplant !== undefined) ||
          (originalMetadata?.healthInfo?.hasTransplant !== null &&
            originalMetadata?.healthInfo?.hasTransplant !== undefined)
        "
      >
        <span i18n class="card__label"
          >Un implant ou un corps étranger t'a-t-il été posé (implant mammaire,
          prothèse, prothèses articulaires, anneau gastrique, stent, etc)?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasTransplant === null ||
                  originalMetadata.healthInfo?.hasTransplant === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.hasTransplant) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasTransplant &&
              originalMetadata?.healthInfo?.hasTransplant !==
                metadata.healthInfo?.hasTransplant
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hasTransplant)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasDiagnostic !== null &&
            metadata?.healthInfo?.hasDiagnostic !== undefined) ||
          (originalMetadata?.healthInfo?.hasDiagnostic !== null &&
            originalMetadata?.healthInfo?.hasDiagnostic !== undefined)
        "
      >
        <span class="card__label" i18n>As-tu des maladies ou affections</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasDiagnostic === null ||
                  originalMetadata.healthInfo?.hasDiagnostic === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.hasDiagnostic) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasDiagnostic &&
              originalMetadata?.healthInfo?.hasDiagnostic !==
                metadata.healthInfo?.hasDiagnostic
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hasDiagnostic)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.jawProblem !== null &&
            metadata?.healthInfo?.jawProblem !== undefined) ||
          (originalMetadata?.healthInfo?.jawProblem !== null &&
            originalMetadata?.healthInfo?.jawProblem !== undefined)
        "
      >
        <span i18n class="card__label"
          >Existe-t-il une malposition de la mâchoire ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.jawProblem === null ||
                  originalMetadata.healthInfo?.jawProblem === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.jawProblem) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.jawProblem &&
              originalMetadata?.healthInfo?.jawProblem !==
                metadata.healthInfo?.jawProblem
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.jawProblem)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.birthProblem !== null &&
            metadata?.healthInfo?.birthProblem !== undefined) ||
          (originalMetadata?.healthInfo?.birthProblem !== null &&
            originalMetadata?.healthInfo?.birthProblem !== undefined)
        "
      >
        <span class="card__label" i18n
          >Souffres-tu d'une infirmité congénitale ou percevez-vous une rente
          LAA ou rente AI ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.birthProblem === null ||
                  originalMetadata.healthInfo?.birthProblem === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.birthProblem) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.birthProblem &&
              originalMetadata?.healthInfo?.birthProblem !==
                metadata.healthInfo?.birthProblem
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.birthProblem)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasEmergencyIntervention !== null &&
            metadata?.healthInfo?.hasEmergencyIntervention !== undefined) ||
          (originalMetadata?.healthInfo?.hasEmergencyIntervention !== null &&
            originalMetadata.healthInfo?.hasEmergencyIntervention !== undefined)
        "
      >
        <span i18n class="card__label"
          >As-tu déjà subi une intervention en ambulatoire ou stationnaire
          ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasEmergencyIntervention ===
                  null ||
                  originalMetadata.healthInfo?.hasEmergencyIntervention ===
                    undefined),
            }"
            >{{
              getBooleanLabel(metadata.healthInfo!.hasEmergencyIntervention)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasEmergencyIntervention &&
              originalMetadata?.healthInfo?.hasEmergencyIntervention !==
                metadata.healthInfo?.hasEmergencyIntervention
            "
            >{{
              getBooleanLabel(
                originalMetadata.healthInfo!.hasEmergencyIntervention
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.isSmoker !== null &&
            metadata?.healthInfo?.isSmoker !== undefined) ||
          (originalMetadata?.healthInfo?.isSmoker !== null &&
            originalMetadata?.healthInfo?.isSmoker !== undefined)
        "
      >
        <span i18n class="card__label"
          >Consommes-tu régulièrement ou as-tu consommé régulièrement de la
          nicotine ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.isSmoker === null ||
                  originalMetadata.healthInfo?.isSmoker === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.isSmoker) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.isSmoker &&
              originalMetadata?.healthInfo?.isSmoker !==
                metadata.healthInfo?.isSmoker
            "
            >{{ getBooleanLabel(originalMetadata.healthInfo!.isSmoker) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasDentalTreatment !== null &&
            metadata?.healthInfo?.hasDentalTreatment !== undefined) ||
          (originalMetadata?.healthInfo?.hasDentalTreatment !== null &&
            originalMetadata?.healthInfo?.hasDentalTreatment !== undefined)
        "
      >
        <span i18n class="card__label"
          >Suis-tu actuellement un traitement dentaire ou est-il prévu que tu en
          suis un ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasDentalTreatment === null ||
                  originalMetadata.healthInfo?.hasDentalTreatment ===
                    undefined),
            }"
            >{{
              getBooleanLabel(metadata.healthInfo!.hasDentalTreatment)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasDentalTreatment &&
              originalMetadata?.healthInfo?.hasDentalTreatment !==
                metadata.healthInfo?.hasDentalTreatment
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hasDentalTreatment)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.healthInfo?.dentalCleaningInterval ||
          originalMetadata?.healthInfo?.dentalCleaningInterval
        "
      >
        <span class="card__label" i18n>Intervalles de nettoyage dentaire</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.healthInfo?.dentalCleaningInterval,
            }"
            >{{
              getDentalIntervalLabel(
                metadata!.healthInfo!.dentalCleaningInterval!
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.dentalCleaningInterval &&
              originalMetadata?.healthInfo?.dentalCleaningInterval !==
                metadata.healthInfo?.dentalCleaningInterval
            "
            >{{
              getDentalIntervalLabel(
                originalMetadata!.healthInfo!.dentalCleaningInterval!
              )
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasTreatment !== null &&
            metadata?.healthInfo?.hasTreatment !== undefined) ||
          (originalMetadata?.healthInfo?.hasTreatment !== null &&
            originalMetadata?.healthInfo?.hasTreatment !== undefined)
        "
      >
        <span i18n class="card__label"
          >Traitement en cours, hospitalisations/opérations effectués ou
          prévus</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasTreatment === null ||
                  originalMetadata.healthInfo?.hasTreatment === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.hasTreatment) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasTreatment &&
              originalMetadata?.healthInfo?.hasTreatment !==
                metadata.healthInfo?.hasTreatment
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hasTreatment)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasMedication !== null &&
            metadata?.healthInfo?.hasMedication !== undefined) ||
          (originalMetadata?.healthInfo?.hasMedication !== null &&
            originalMetadata?.healthInfo?.hasMedication !== undefined)
        "
      >
        <span class="card__label" i18n>Prend des médicaments</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasMedication === null ||
                  originalMetadata.healthInfo?.hasMedication === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.hasMedication) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasMedication &&
              originalMetadata?.healthInfo?.hasMedication !==
                metadata.healthInfo?.hasMedication
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hasMedication)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.insuranceRefused !== null &&
            metadata?.healthInfo?.insuranceRefused !== undefined) ||
          (originalMetadata?.healthInfo?.insuranceRefused !== null &&
            originalMetadata?.healthInfo?.insuranceRefused !== undefined)
        "
      >
        <span i18n class="card__label"
          >Au cours des 5 dernières années, une demande d'assureur de ta part à
          un assureur-maladie, assureur-accidents ou assureur-vie a-t-elle été
          refusée, reportée ou admise seulement à des conditions aggravés
          ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.insuranceRefused === null ||
                  originalMetadata.healthInfo?.insuranceRefused === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.insuranceRefused) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.insuranceRefused &&
              originalMetadata?.healthInfo?.insuranceRefused !==
                metadata.healthInfo?.insuranceRefused
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.insuranceRefused)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.smokeOrDrink !== null &&
            metadata?.healthInfo?.smokeOrDrink !== undefined) ||
          (originalMetadata?.healthInfo?.smokeOrDrink !== null &&
            originalMetadata?.healthInfo?.smokeOrDrink !== undefined)
        "
      >
        <span i18n class="card__label"
          >As-tu, par le passé régulièrement fumé ou consommé de l'alcool, ou
          consommes-tu actuellement ou as-tu par le passé consommé de la drogue
          ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.smokeOrDrink === null ||
                  originalMetadata.healthInfo?.smokeOrDrink === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.smokeOrDrink) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.smokeOrDrink &&
              originalMetadata?.healthInfo?.smokeOrDrink !==
                metadata.healthInfo?.smokeOrDrink
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.smokeOrDrink)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasHeartOrPsychologicalOrTumor !== null &&
            metadata?.healthInfo?.hasHeartOrPsychologicalOrTumor !==
              undefined) ||
          (originalMetadata?.healthInfo?.hasHeartOrPsychologicalOrTumor !==
            null &&
            originalMetadata?.healthInfo?.hasHeartOrPsychologicalOrTumor !==
              undefined)
        "
      >
        <span i18n class="card__label"
          >As-tu déjà souffert d'une maladie tumorale, d'une hernie discale,
          d'une maladie psychique ou d'une maladie cardiovasculaire ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasHeartOrPsychologicalOrTumor ===
                  null ||
                  originalMetadata.healthInfo
                    ?.hasHeartOrPsychologicalOrTumor === undefined),
            }"
            >{{
              getBooleanLabel(
                metadata.healthInfo!.hasHeartOrPsychologicalOrTumor
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasHeartOrPsychologicalOrTumor &&
              originalMetadata?.healthInfo?.hasHeartOrPsychologicalOrTumor !==
                metadata.healthInfo?.hasHeartOrPsychologicalOrTumor
            "
            >{{
              getBooleanLabel(
                originalMetadata.healthInfo!.hasHeartOrPsychologicalOrTumor
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.hasSurgery !== null &&
            metadata?.healthInfo?.hasSurgery !== undefined) ||
          (originalMetadata?.healthInfo?.hasSurgery !== null &&
            originalMetadata?.healthInfo?.hasSurgery !== undefined)
        "
      >
        <span i18n class="card__label"
          >As-tu déjà eu un accident à la suite duquel tu as dû subir une
          intervention chirurgicale ou un traitement ambulatoire et/ou
          hospitalier de plus de quatre semaines (y compris les
          thérapies/médicaments)</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.hasSurgery === null ||
                  originalMetadata.healthInfo?.hasSurgery === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.hasSurgery) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.hasSurgery &&
              originalMetadata?.healthInfo?.hasSurgery !==
                metadata.healthInfo?.hasSurgery
            "
            >{{
              getBooleanLabel(originalMetadata.healthInfo!.hasSurgery)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.healthInfo?.isDrinker !== null &&
            metadata?.healthInfo?.isDrinker !== undefined) ||
          (originalMetadata?.healthInfo?.isDrinker !== null &&
            originalMetadata?.healthInfo?.isDrinker !== undefined)
        "
      >
        <span i18n class="card__label"
          >Consommes-tu régulièrement ou as-tu consommé régulièrement de
          l'alcool ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.healthInfo?.isDrinker === null ||
                  originalMetadata.healthInfo?.isDrinker === undefined),
            }"
            >{{ getBooleanLabel(metadata.healthInfo!.isDrinker) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.isDrinker &&
              originalMetadata?.healthInfo?.isDrinker !==
                metadata.healthInfo?.isDrinker
            "
            >{{ getBooleanLabel(originalMetadata.healthInfo!.isDrinker) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.healthInfo?.dentalCheckInterval ||
          originalMetadata?.healthInfo?.dentalCheckInterval
        "
      >
        <span class="card__label" i18n>Intervalles de contrôles dentaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.healthInfo?.dentalCheckInterval,
            }"
            >{{
              getDentalIntervalLabel(metadata!.healthInfo!.dentalCheckInterval!)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.healthInfo?.dentalCheckInterval &&
              originalMetadata?.healthInfo?.dentalCheckInterval !==
                metadata.healthInfo?.dentalCheckInterval
            "
            >{{
              getDentalIntervalLabel(
                originalMetadata!.healthInfo!.dentalCheckInterval!
              )
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="metadata?.contractAddress || originalMetadata?.contractAddress"
>
  <div cardTitle i18n>Informations sur l'assureur actuel</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Rue</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.contractAddress?.street,
            }"
            >{{ metadata?.contractAddress?.street }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.contractAddress?.street &&
              originalMetadata?.contractAddress?.street !==
                metadata.contractAddress?.street
            "
            >{{ originalMetadata?.contractAddress?.street }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>Numéro</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.contractAddress?.number,
            }"
            >{{ metadata?.contractAddress?.number }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.contractAddress?.number &&
              originalMetadata?.contractAddress?.number !==
                metadata.contractAddress?.number
            "
            >{{ originalMetadata?.contractAddress?.number }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>Complément d'adresse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.contractAddress?.complement,
            }"
            >{{ metadata?.contractAddress?.complement }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.contractAddress?.complement &&
              originalMetadata?.contractAddress?.complement !==
                metadata.contractAddress?.complement
            "
            >{{ originalMetadata?.contractAddress?.complement }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Code postal</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.contractAddress?.zipCode,
            }"
            >{{ metadata?.contractAddress?.zipCode }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.contractAddress?.zipCode &&
              originalMetadata?.contractAddress?.zipCode !==
                metadata.contractAddress?.zipCode
            "
            >{{ originalMetadata?.contractAddress?.zipCode }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>Ville</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.contractAddress?.city,
            }"
            >{{ metadata?.contractAddress?.city }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.contractAddress?.city &&
              originalMetadata?.contractAddress?.city !==
                metadata.contractAddress?.city
            "
            >{{ originalMetadata?.contractAddress?.city }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>C/O</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.contractAddress?.co,
            }"
            >{{ metadata?.contractAddress?.co }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.contractAddress?.co &&
              originalMetadata?.contractAddress?.co !==
                metadata.contractAddress?.co
            "
            >{{ originalMetadata?.contractAddress?.co }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="metadata?.personalInfo || originalMetadata?.personalInfo"
>
  <div cardTitle i18n>Informations personnelles</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Taille</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.personalInfo?.height,
            }"
            >{{ metadata?.personalInfo?.height }}
            <ng-container *ngIf="metadata?.personalInfo?.height"
              >cm</ng-container
            ></span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.personalInfo?.height &&
              originalMetadata?.personalInfo?.height !==
                metadata.personalInfo?.height
            "
            >{{ originalMetadata?.personalInfo?.height }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>Poids</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.personalInfo?.weight,
            }"
            >{{ metadata?.personalInfo?.weight }}
            <ng-container *ngIf="metadata?.personalInfo?.weight"
              >kg</ng-container
            ></span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.personalInfo?.weight &&
              originalMetadata?.personalInfo?.weight !==
                metadata.personalInfo?.weight
            "
            >{{ originalMetadata?.personalInfo?.weight }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>BMI</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.personalInfo?.bmi,
            }"
            >{{ metadata?.personalInfo?.bmi }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.personalInfo?.bmi &&
              originalMetadata?.personalInfo?.bmi !== metadata.personalInfo?.bmi
            "
            >{{ originalMetadata?.personalInfo?.bmi }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="metadata?.doctor || originalMetadata?.doctor"
>
  <div cardTitle i18n>Médecin</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Nom et prénom</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !(
                  originalMetadata.doctor?.firstname &&
                  originalMetadata.doctor?.lastname
                ),
            }"
          >
            {{ metadata?.doctor?.firstname }}
            {{ metadata?.doctor?.lastname }}
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              (originalMetadata?.doctor?.firstname ||
                originalMetadata?.doctor?.lastname) &&
              (originalMetadata?.doctor?.firstname !==
                metadata.doctor?.firstname ||
                originalMetadata?.doctor?.lastname !==
                  metadata.doctor?.lastname)
            "
          >
            {{ originalMetadata?.doctor?.firstname }}
            {{ originalMetadata?.doctor?.lastname }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>N° de rue</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.doctor?.street,
            }"
            >{{ metadata?.doctor?.streetNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.doctor?.streetNumber &&
              originalMetadata?.doctor?.streetNumber !==
                metadata.doctor?.streetNumber
            "
            >{{ originalMetadata?.doctor?.streetNumber }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>Rue</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.doctor?.street,
            }"
            >{{ metadata?.doctor?.street }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.doctor?.street &&
              originalMetadata?.doctor?.street !== metadata.doctor?.street
            "
            >{{ originalMetadata?.doctor?.street }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Code postal</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.doctor?.zipCode,
            }"
            >{{ metadata?.doctor?.zipCode }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.doctor?.zipCode &&
              originalMetadata?.doctor?.zipCode !== metadata.doctor?.zipCode
            "
            >{{ originalMetadata?.doctor?.zipCode }}</span
          >
        </div>
      </div>
      <div class="card__row">
        <span class="card__label" i18n>Ville</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.doctor?.city,
            }"
          >
            {{ metadata?.doctor?.city }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.doctor?.city &&
              originalMetadata?.doctor?.city !== metadata.doctor?.city
            "
          >
            {{ originalMetadata?.doctor?.city }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
